"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.extractHeaders = extractHeaders;
exports.unlazyAll = void 0;
var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/entries"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
/**
 * Node fetch is currently incompatible with the spec but provides another
 * method to grab headers.  This can be removed once the 2.0.0 branch comes
 * out which is more spec compliant.
 */
function extractHeaders(response) {
  var _context;
  if (!response.headers) return response.headers;
  if (response.headers.raw) return response.headers.raw();
  if ((0, _entries.default)(response.headers)) return [...(0, _entries.default)(_context = response.headers).call(_context)];
  return response.headers;
}
var isThenable = x => x && typeof x.then === 'function';

/**
 * Promise.all, but it will not resolve until all promises either resolve
 * or reject (Promise.all immediately rejects when any promise rejects).
 */
var unlazyAll = promises => new _promise.default((resolve, reject) => {
  var _promises = [...promises];
  var rejected = false;
  var results = [];
  var maybeFinish = () => {
    var _context2;
    if (results.length !== _promises.length) return;
    var finish = rejected ? reject : resolve;
    finish((0, _map.default)(_context2 = (0, _sort.default)(results).call(results, (a, b) => a.index - b.index)).call(_context2, _ref => {
      var {
        value
      } = _ref;
      return value;
    }));
  };
  (0, _forEach.default)(_promises).call(_promises, (promise, index) => {
    if (!isThenable(promise)) {
      results.push({
        index,
        value: promise
      });
      return;
    }
    promise.then(value => {
      results.push({
        index,
        value
      });
      maybeFinish();
    }).catch(value => {
      rejected = true;
      results.push({
        index,
        value
      });
      maybeFinish();
    });
  });
  maybeFinish();
});
exports.unlazyAll = unlazyAll;